// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file gportal/api/user/v1/discord.proto (package gportal.api.user.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message gportal.api.user.v1.DiscordLootPassStatus
 */
export class DiscordLootPassStatus extends Message<DiscordLootPassStatus> {
  /**
   * Defines if the user has connected their Discord account.
   *
   * @generated from field: bool has_discord_connection = 1;
   */
  hasDiscordConnection = false;

  /**
   * Defines if the user has an active Loot Pass subscription.
   *
   * @generated from field: bool has_loot_pass_subscription = 2;
   */
  hasLootPassSubscription = false;

  /**
   * Defines if the user has joined the Discord server.
   *
   * @generated from field: bool has_joined_discord_server = 3;
   */
  hasJoinedDiscordServer = false;

  /**
   * Defines if the user has been assigned the Loot Pass role.
   *
   * @generated from field: bool has_role_assigned = 4;
   */
  hasRoleAssigned = false;

  constructor(data?: PartialMessage<DiscordLootPassStatus>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.user.v1.DiscordLootPassStatus";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "has_discord_connection", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "has_loot_pass_subscription", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "has_joined_discord_server", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "has_role_assigned", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DiscordLootPassStatus {
    return new DiscordLootPassStatus().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DiscordLootPassStatus {
    return new DiscordLootPassStatus().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DiscordLootPassStatus {
    return new DiscordLootPassStatus().fromJsonString(jsonString, options);
  }

  static equals(a: DiscordLootPassStatus | PlainMessage<DiscordLootPassStatus> | undefined, b: DiscordLootPassStatus | PlainMessage<DiscordLootPassStatus> | undefined): boolean {
    return proto3.util.equals(DiscordLootPassStatus, a, b);
  }
}

